export default "__VITE_ASSET__BGUXn$tT__"